let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("4A3f7")).then(() => parcelRequire('i2p5v'));